"use client";
import { Box, styled } from "@mui/material";
import { JSX } from "react";

export interface HeroBannerProps {
  background?: string;
  video?: string;
  children: JSX.Element;
  width?: string;
  height?: string;
}

const FilterBox = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background:
    linear-gradient(0deg, rgba(11, 17, 20, 0.4), rgba(11, 17, 20, 0.4)),
    linear-gradient(360deg, rgba(11, 17, 20, 0) 37.67%, #0b1114 89.99%);
`;
export function HeroBanner(props: HeroBannerProps) {
  const { background, children, width, height, video } = props;

  return (
    <Box
      sx={{
        backgroundImage: `url(${background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: width ? width : "100%",
        height: height ? height : "100vh",
        borderRadius: "0px 0px 40px 40px",
        position: "relative",
      }}
      pt={16}
    >
      {video && (
        <video
          playsInline={true}
          controls={false}
          muted={true}
          autoPlay={true}
          loop={true}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            position: "absolute",
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            zIndex: 0,
          }}
        >
          <source src={video} type="video/mp4" />
        </video>
      )}
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
        }}
        height="100%"
        width="100%"
      >
        {children}
      </Box>
      <FilterBox />
    </Box>
  );
}
